// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"451":"4b7cd09e","453":"440fd0f4"}[chunkId] + ".chunk.js";
};